import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 18 18",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M2.925 7.986h2.151a4.05 4.05 0 0 1 7.845 0h2.154a1.013 1.013 0 1 1 0 2.025h-2.153a4.05 4.05 0 0 1-7.846 0H2.925a1.013 1.013 0 1 1 0-2.025M9 11.023a2.025 2.025 0 1 0 0-4.05 2.025 2.025 0 0 0 0 4.05"
	})]
});
const ForwardRef = forwardRef(SvgCommit);
export { ForwardRef as ReactComponent };
